import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import {
  AdmissionNo,
  Hostel,
  PickupPoint,
  VehicleNumber,
  academicYear,
  mothertongue,
  names,
  rollno,
  roomNO,
  route,
} from "../../../../core/common/selectoption/selectoption";
import { status_data, allClass, allSection, gender_data, nationality_data, religion_data, bloodGroup, title_data } from "../../../../core/common/selectoption/formselection"
import { TagsInput } from "react-tag-input-component";
import CommonSelect from "../../../../core/common/commonSelect";
import Select, { SingleValue } from 'react-select';
import { useLocation } from "react-router-dom";
import axios from "axios";
import ReactDOM from "react-dom";

const AddStudent = () => {
  const routes = all_routes;

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [owner, setOwner] = useState<string[]>(['English', 'Malay', 'Mandarin', 'Tamil']);
  const [owner1, setOwner1] = useState<string[]>([]);
  const [owner2, setOwner2] = useState<string[]>([]);
  const [defaultDate, setDefaultDate] = useState<dayjs.Dayjs | null>(null);
  const [newContents, setNewContents] = useState<number[]>([0]);

  const [student_id, setStudentId] = useState('');
  const [academic_year, setAcademicYear] = useState<string>('');
  const [admission_number, setAdmissionNumber] = useState('');

  const [role_number, setRoleNumber] = useState('R0001');
  const [first_name, setFirstName] = useState('');
  const [last_name, setLastName] = useState('');
  const [full_name, setFullName] = useState('');
  const [username, setUsername] = useState('');
  const [gender, setGender] = useState('');
  const [class_id, setClassId] = useState('1');
  const [section_id, setSectionId] = useState('1');
  const [nric_passport, setNricPassport] = useState('');
  const [contact_no, setContact] = useState('');
  const [email, setEmail] = useState('');

  const [blood_group, setBloodGrp] = useState('');
  const [religion, setReligion] = useState('');
  const [race, setRace] = useState('');
  const [language_known, setLanguage] = useState<string[]>(['English', 'Malay', 'Mandarin', 'Tamil']);
  const [nationality, setNationality] = useState('');
  const [mother_tongue, setMotherTongue] = useState('');
  const [status, setStatus] = useState('');
  const [create_by, setCreateBy] = useState('Admin');
  const [update_by, setUpdateBy] = useState('Admin');

  const [admission_date, setAdmissionDate] = useState<Date | null>(null);
  const [date_of_birth, setDateOfBirth] = useState<Date | null>(null);

  //const [image, setImage] = useState('');
  const [image, setImage] = useState<File | null>(null); // State for the image file
  const [imagePreview, setImagePreview] = useState<string | null>(null); // State for the image preview

  const [imagefather, setImageFather] = useState<File | null>(null);
  const [imageFatherPreview, setImageFatherPreview] = useState<string | null>(null); // State for the image preview

  const [imagemother, setImageMother] = useState<File | null>(null);
  const [imageMotherPreview, setImageMotherPreview] = useState<string | null>(null); // State for the image preview

  const [imageguardian, setImageGuardian] = useState<File | null>(null);
  const [imageGuardianPreview, setImageGuardianPreview] = useState<string | null>(null); // State for the image preview

  // Father details
  const [father_titlename, setFatherTitleName] = useState('');
  const [father_fullname, setFatherFullName] = useState('');
  const [father_email, setFatherEmail] = useState('');
  const [father_contactno, setFatherContactNo] = useState('');
  const [father_occupation, setFatherOccupation] = useState('');

  // Mother details
  const [mother_titlename, setMotherTitleName] = useState('');
  const [mother_fullname, setMotherFullName] = useState('');
  const [mother_email, setMotherEmail] = useState('');
  const [mother_contactno, setMotherContactNo] = useState('');
  const [mother_occupation, setMotherOccupation] = useState('');

  // Guardian details
  const [guardian_titlename, setGuardianTitleName] = useState('');
  const [guardian_fullname, setGuardianFullName] = useState('');
  const [guardian_email, setGuardianEmail] = useState('');
  const [guardian_contactno, setGuardianContactNo] = useState('');
  const [guardian_occupation, setGuardianOccupation] = useState('');
  const [guardian_relation, setGuardianRelation] = useState('');
  const [guardian_address, setGuardianAddress] = useState('');

  const [current_address, setCurrentAddress] = useState('');
  const [permanent_address, setPermanentAddress] = useState('');

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const location = useLocation();
  const addNewContent = () => {
    setNewContents([...newContents, newContents.length]);
  };
  const removeContent = (index: any) => {
    setNewContents(newContents.filter((_, i) => i !== index));
  };
  useEffect(() => {
    if (location.pathname === routes.editStudent) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
      const day = String(today.getDate()).padStart(2, "0");
      const formattedDate = `${month}-${day}-${year}`;
      const defaultValue = dayjs(formattedDate);
      setIsEdit(true)
      setOwner(["English"])
      setOwner1(["Medecine Name"])
      setOwner2(["Allergy", "Skin Allergy"])
      setDefaultDate(defaultValue)
      console.log(formattedDate, 11);

      if (academicYear.length > 0) {
        setAcademicYear(academicYear[0].value);
      }
    } else {
      setIsEdit(false);
      setDefaultDate(null);
      setAcademicYear('');

    }

    if (status_data.length > 0) {
      setStatus(status_data[0].value);
    } else {
      setStatus('');
    }

    if (allClass.length > 0) {
      setClassId(allClass[0].value);
    } else {
      setClassId('');
    }

    if (allSection.length > 0) {
      setSectionId(allSection[0].value);
    } else {
      setSectionId('');
    }

    if (gender_data.length > 0) {
      setGender(gender_data[0].value);
    } else {
      setGender('');
    }

    if (bloodGroup.length > 0) {
      setBloodGrp(bloodGroup[0].value);
    } else {
      setBloodGrp('');
    }

    if (nationality_data.length > 0) {
      setNationality(nationality_data[0].value);
    } else {
      setNationality('');
    }

    if (religion_data.length > 0) {
      setReligion(religion_data[0].value);
    } else {
      setReligion('');
    }

  }, [location.pathname, academicYear, status_data, allClass, allSection, gender_data, bloodGroup, nationality_data, religion_data]);

  const handleAcademicYearChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setAcademicYear(selectedOption ? selectedOption.value : '');
    if (selectedOption) {
      console.log('Academic Year Selected:', selectedOption.value, 'Label:', selectedOption.label);
    } else {
      console.warn('Academic Year selection cleared or invalid.');
    }
  };

  const handleStatusChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setStatus(selectedOption ? selectedOption.value : '');
  };

  const handleClassChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setClassId(selectedOption ? selectedOption.value : '');
  };

  const handleSectionChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setSectionId(selectedOption ? selectedOption.value : '');
  };

  const handleGenderChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setGender(selectedOption ? selectedOption.value : '');
  };

  const handleBloodChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setBloodGrp(selectedOption ? selectedOption.value : '');
  };

  const handleNationalityChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setNationality(selectedOption ? selectedOption.value : '');
  };

  const handleReligionChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setReligion(selectedOption ? selectedOption.value : '');
  };

  const handleFatherTitleChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setFatherTitleName(selectedOption ? selectedOption.value : '');
  };

  const handleMotherTitleChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setMotherTitleName(selectedOption ? selectedOption.value : '');
  };

  const handleGuardianTitleChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setGuardianTitleName(selectedOption ? selectedOption.value : '');
  };

  const handleLanguageChange = (newTags: string[]) => {
    setLanguage(newTags);
    console.log("Languages Known:", newTags);
  };

  const handleDateChange = (date: Date | null, fieldName: string) => {
    if (fieldName === 'admission_date') {
      setAdmissionDate(date);
      if (date) {
        console.log(`${fieldName} Formatted Date:`, dayjs(date).format('YYYY-MM-DD'));
      } else {
        console.log(`${fieldName} Formatted Date: null`);
      }
    } else if (fieldName === 'date_of_birth') {
      setDateOfBirth(date);
      if (date) {
        console.log(`${fieldName} Formatted Date:`, dayjs(date).format('YYYY-MM-DD'));
      } else {
        console.log(`${fieldName} Formatted Date: null`);
      }
    }
  };

  const handleStudentImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; // Get the selected file
    if (file) {
      // Use FileReader to read the file and set it as a preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(file); // Set the file in state (for later upload)
        setImagePreview(reader.result as string); // Set the image data URL for preview
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    } else {
      setImage(null); // Clear the file in state
      setImagePreview(null); // Clear the image preview
    }
  };

  const handleFatherImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; // Get the selected file
    if (file) {
      // Use FileReader to read the file and set it as a preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageFather(file); // Set the file in state (for later upload)
        setImageFatherPreview(reader.result as string); // Set the image data URL for preview
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    } else {
      setImageFather(null); // Clear the file in state
      setImageFatherPreview(null); // Clear the image preview
    }
  };


  const handleMotherImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; // Get the selected file
    if (file) {
      // Use FileReader to read the file and set it as a preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageMother(file); // Set the file in state (for later upload)
        setImageMotherPreview(reader.result as string); // Set the image data URL for preview
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    } else {
      setImageMother(null); // Clear the file in state
      setImageMotherPreview(null); // Clear the image preview
    }
  };

  const handleGuardianImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; // Get the selected file
    if (file) {
      // Use FileReader to read the file and set it as a preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageGuardian(file); // Set the file in state (for later upload)
        setImageGuardianPreview(reader.result as string); // Set the image data URL for preview
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    } else {
      setImageGuardian(null); // Clear the file in state
      setImageGuardianPreview(null); // Clear the image preview
    }
  };

  const formattedAdmissionDate = dayjs(admission_date).format('YYYY-MM-DD');
  const formattedDateOfBirth = dayjs(date_of_birth).format('YYYY-MM-DD');

  const studentSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const parentFormData = new FormData();
    parentFormData.append('father_titlename', father_titlename);
    parentFormData.append('father_fullname', father_fullname);
    parentFormData.append('father_email', father_email);
    parentFormData.append('father_contactno', father_contactno);
    parentFormData.append('father_occupation', father_occupation);
    parentFormData.append('mother_titlename', mother_titlename);
    parentFormData.append('mother_fullname', mother_fullname);
    parentFormData.append('mother_email', mother_email);
    parentFormData.append('mother_contactno', mother_contactno);
    parentFormData.append('mother_occupation', mother_occupation);
    parentFormData.append('guardian_titlename', guardian_titlename);
    parentFormData.append('guardian_fullname', guardian_fullname);
    parentFormData.append('guardian_email', guardian_email);
    parentFormData.append('guardian_contactno', guardian_contactno);
    parentFormData.append('guardian_occupation', guardian_occupation);
    parentFormData.append('guardian_relation', guardian_relation);
    parentFormData.append('guardian_address', guardian_address);
    parentFormData.append('permanent_address', permanent_address);
    parentFormData.append('current_address', current_address);
    if (imagefather) {
      parentFormData.append('imagefather', imagefather);
    } else {
      parentFormData.append('imagefather', '');
      console.error("No father image selected.");
    }
    if (imagemother) {
      parentFormData.append('imagemother', imagemother);
    } else {
      parentFormData.append('imagemother', '');
      console.error("No mother image selected.");
    }
    if (imageguardian) {
      parentFormData.append('imageguardian', imageguardian);
    } else {
      parentFormData.append('imageguardian', '');
      console.error("No guardian image selected.");
    }
    parentFormData.append('create_by', create_by);

    try {
      // Add Parent API Call
      const parentResponse = await axios.post('/api/parent/addParent', parentFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('parentResponse: ', parentResponse);
      const parentUid = parentResponse?.data?.data?.parent_uid; // Safe access
      console.log('PARENT UID: ',parentUid);
      if (parentResponse.status === 200 || parentResponse.status === 201) {
        // alert("Parent added successfully");
        setSuccessMessage("Parent added successfully");

        // Prepare student form data
        const studentFormData = new FormData();
        studentFormData.append('student_id', student_id);
        studentFormData.append('academic_year', academic_year);
        studentFormData.append('admission_number', admission_number);
        studentFormData.append('admission_date', formattedAdmissionDate);
        studentFormData.append('role_number', role_number);
        studentFormData.append('first_name', first_name);
        studentFormData.append('last_name', last_name);
        studentFormData.append('full_name', full_name);
        studentFormData.append('username', username);
        studentFormData.append('gender', gender);
        studentFormData.append('class_id', class_id);
        studentFormData.append('section_id', section_id);
        studentFormData.append('nric_passport', nric_passport);
        studentFormData.append('contact_no', contact_no);
        studentFormData.append('email', email);
        studentFormData.append('date_of_birth', formattedDateOfBirth);
        studentFormData.append('blood_group', blood_group);
        studentFormData.append('religion', religion);
        studentFormData.append('race', race);
        studentFormData.append('language_known', JSON.stringify(language_known));
        studentFormData.append('mother_tongue', mother_tongue);
        studentFormData.append('nationality', nationality);
        studentFormData.append('parent_uid', parentUid);
        studentFormData.append('status', status);
        if (image) {
          studentFormData.append('image', image);
        } else {
          studentFormData.append('image', '');
          console.error("No image selected.");
        }
        studentFormData.append('create_by', create_by);
        studentFormData.append('update_by', update_by);

        // Add Student API Call
        const studentResponse = await axios.post('/api/student/addStudent', studentFormData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        console.log('studentResponse: ', studentResponse);
        if (studentResponse.status === 200 || studentResponse.status === 201) {
          // alert('Student added successfully');
          setSuccessMessage("Student added successfully");

          setTimeout(() => {
            navigate('/student/student-list');
          }, 2000); // 2 seconds delay

        } else {
          // alert('Student addition failed');
          setErrorMessage("Student addition failed");
        }
      } else {
        // alert("Parent addition failed");
        setErrorMessage("Parent addition failed");        
      }
    } catch (error) {
      //alert('Error occurred during submission');
      console.log(error);
      setErrorMessage("Error occurred during submission");
    }
  };
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content content-two">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="mb-1">{isEdit ? 'Edit' : 'Add'} Student</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.studentList}>Students</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {isEdit ? 'Edit' : 'Add'} Student
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* /Page Header */}
          {successMessage && (
            <div className="alert alert-success" role="alert">
              {successMessage}
            </div>
          )}
          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )}
          <div className="row">
            <div className="col-md-12">
              <form onSubmit={studentSubmit}>
                {/* Personal Information */}
                <div className="card">
                  <div className="card-header bg-light">
                    <div className="d-flex align-items-center">
                      <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                        <i className="ti ti-info-square-rounded fs-16" />
                      </span>
                      <h4 className="text-dark">Personal Information</h4>
                    </div>
                  </div>
                  <div className="card-body pb-1">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">
                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                            {imagePreview ? (
                              // Display the uploaded image preview
                              <img
                                src={imagePreview}
                                alt="Uploaded Preview"
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              />
                            ) : (
                              // Display the default icon if no image is selected
                              <i className="ti ti-photo-plus fs-16" />
                            )}
                          </div>
                          <div className="profile-upload">
                            <div className="profile-uploader d-flex align-items-center">
                              <div className="drag-upload-btn mb-3">
                                Upload
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  name="image"
                                  onChange={handleStudentImageChange}
                                />
                              </div>
                              <Link to="#" className="btn btn-primary mb-3">
                                Remove
                              </Link>
                            </div>
                            <p className="fs-12">
                              Upload image size 4MB, Format JPG, PNG, SVG
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row row-cols-xxl-5 row-cols-md-6">
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Academic Year</label>
                          {/* <CommonSelect
                            className="select"
                            options={academicYear}
                            defaultValue={isEdit ? academicYear[0] : undefined}
                            value={academic_year} onChange={(e) => setAcademicYear(e.target.value)} 
                          /> */}
                          <Select
                            className="select"
                            options={academicYear}
                            defaultValue={isEdit ? academicYear[0] : undefined}
                            value={academicYear.find(option => option.value === academic_year)}
                            onChange={handleAcademicYearChange}
                          />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Admission Number</label>
                          <input type="text" className="form-control"
                            value={admission_number} onChange={(e) => { setAdmissionNumber(e.target.value); }} />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Admission Date</label>
                          <div className="input-icon position-relative">
                            {/* <DatePicker
                                className="form-control datetimepicker"
                                selected={admission_date}
                                onChange={(date) => handleDateChange(date, 'admission_date')}
                                dateFormat="dd-MM-yyyy"
                                placeholderText="Select Date"
                              /> */}
                            <DatePicker
                              className="form-control datetimepicker"
                              value={admission_date} // use state value
                              onChange={(date) => handleDateChange(date, 'admission_date')}
                              format={{
                                format: "DD-MM-YYYY",
                                type: "mask",
                              }}
                              placeholder="Select Date"
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar" />
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Roll Number</label>
                          <input type="text" className="form-control" defaultValue={isEdit? '35013': undefined} />
                        </div>
                      </div> */}
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Status</label>
                          {/* <CommonSelect
                            className="select"
                            options={status_data}
                            defaultValue={isEdit ? status_data[0] : undefined}
                          /> */}
                          <Select
                            className="select"
                            options={status_data}
                            defaultValue={isEdit ? status_data[0] : undefined}
                            value={status_data.find(option => option.value === status)}
                            onChange={handleStatusChange}
                          />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">NRIC/Passport</label>
                          <input type="text" className="form-control"
                            value={nric_passport} onChange={(e) => setNricPassport(e.target.value)} />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">First Name</label>
                          <input type="text" className="form-control"
                            value={first_name} onChange={(e) => setFirstName(e.target.value)} />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Last Name</label>
                          <input type="text" className="form-control"
                            value={last_name} onChange={(e) => setLastName(e.target.value)} />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Full Name</label>
                          <input type="text" className="form-control"
                            value={full_name} onChange={(e) => setFullName(e.target.value)} />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Class</label>
                          {/* <CommonSelect
                            className="select"
                            options={allClass}
                            defaultValue={isEdit ? allClass[0] : undefined}
                          /> */}
                          <Select
                            className="select"
                            options={allClass}
                            defaultValue={isEdit ? allClass[0] : undefined}
                            value={allClass.find(option => option.value === class_id)}
                            onChange={handleClassChange}
                          />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Section</label>
                          {/* <CommonSelect
                            className="select"
                            options={allSection}
                            defaultValue={isEdit ? allSection[0] : undefined}
                          /> */}
                          <Select
                            className="select"
                            options={allSection}
                            defaultValue={isEdit ? allSection[0] : undefined}
                            value={allSection.find(option => option.value === section_id)}
                            onChange={handleSectionChange}
                          />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Gender</label>
                          {/* <CommonSelect
                            className="select"
                            options={gender_data}
                            defaultValue={isEdit ? gender_data[0] : undefined}
                          /> */}
                          <Select
                            className="select"
                            options={gender_data}
                            defaultValue={isEdit ? gender_data[0] : undefined}
                            value={gender_data.find(option => option.value === gender)}
                            onChange={handleGenderChange}
                          />
                        </div>
                      </div>

                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Date of Birth
                          </label>
                          <div className="input-icon position-relative">
                            {/* <DatePicker
                              className="form-control datetimepicker"
                              selected={date_of_birth}
                              onChange={(date) => handleDateChange(date, 'date_of_birth')}
                              dateFormat="dd-MM-yyyy"
                              placeholderText="Select Date"
                            /> */}
                            <DatePicker
                              className="form-control datetimepicker"
                              value={date_of_birth} // use state value
                              onChange={(date) => handleDateChange(date, 'date_of_birth')}
                              format={{
                                format: "DD-MM-YYYY",
                                type: "mask",
                              }}
                              placeholder="Select Date"
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar" />
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Blood Group</label>
                          {/* <CommonSelect
                            className="select"
                            options={bloodGroup}
                            defaultValue={isEdit ? bloodGroup[0] : undefined}
                          /> */}
                          <Select
                            className="select"
                            options={bloodGroup}
                            defaultValue={isEdit ? bloodGroup[0] : undefined}
                            value={bloodGroup.find(option => option.value === blood_group)}
                            onChange={handleBloodChange}
                          />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Nationality</label>
                          {/* <CommonSelect
                            className="select"
                            options={nationality_data}
                            defaultValue={isEdit ? nationality_data[0] : undefined}
                          /> */}
                          <Select
                            className="select"
                            options={nationality_data}
                            defaultValue={isEdit ? nationality_data[0] : undefined}
                            value={nationality_data.find(option => option.value === blood_group)}
                            onChange={handleNationalityChange}
                          />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Religion</label>
                          {/* <CommonSelect
                            className="select"
                            options={religion_data}
                            defaultValue={isEdit ? religion_data[0] : undefined}
                          /> */}
                          <Select
                            className="select"
                            options={religion_data}
                            defaultValue={isEdit ? religion_data[0] : undefined}
                            value={religion_data.find(option => option.value === blood_group)}
                            onChange={handleReligionChange}
                          />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Primary Contact Number
                          </label>
                          <input type="text" className="form-control"
                            value={contact_no} onChange={(e) => setContact(e.target.value)} />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Email Address</label>
                          <input type="email" className="form-control"
                            value={email} onChange={(e) => setEmail(e.target.value)} />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Race</label>
                          <input type="text" className="form-control"
                            value={race} onChange={(e) => setRace(e.target.value)} />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Mother Tongue</label>
                          <input type="text" className="form-control"
                            value={mother_tongue} onChange={(e) => setMotherTongue(e.target.value)} />
                        </div>
                      </div>
                      <div className="col-xxl col-xl-3 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Language Known</label>
                          <TagsInput
                            value={language_known}
                            onChange={handleLanguageChange}
                            placeHolder="Enter languages"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Personal Information */}
                {/* Parents & Guardian Information */}
                <div className="card">
                  <div className="card-header bg-light">
                    <div className="d-flex align-items-center">
                      <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                        <i className="ti ti-user-shield fs-16" />
                      </span>
                      <h4 className="text-dark">
                        Parents &amp; Guardian Information
                      </h4>
                    </div>
                  </div>
                  <div className="card-body pb-0">
                    <div className="border-bottom mb-3">
                      <h5 className="mb-3">Father’s Info</h5>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">
                            <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                              {imageFatherPreview ? (
                                // Display the uploaded image preview
                                <img
                                  src={imageFatherPreview}
                                  alt="Uploaded Preview Father Image"
                                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                              ) : (
                                // Display the default icon if no image is selected
                                <i className="ti ti-photo-plus fs-16" />
                              )}
                            </div>
                            <div className="profile-upload">
                              <div className="profile-uploader d-flex align-items-center">
                                <div className="drag-upload-btn mb-3">
                                  Upload
                                  <input
                                    type="file"
                                    className="form-control image-sign"
                                    name="imagefather"
                                    onChange={handleFatherImageChange}
                                  />
                                </div>
                                <Link to="#" className="btn btn-primary mb-3">
                                  Remove
                                </Link>
                              </div>
                              <p className="fs-12">
                                Upload image size 4MB, Format JPG, PNG, SVG
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Father Title</label>
                            <Select
                              className="select"
                              options={title_data}
                              defaultValue={isEdit ? title_data[0] : undefined}
                              value={title_data.find(option => option.value === father_titlename)}
                              onChange={handleFatherTitleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Father Name</label>
                            <input type="text" className="form-control"
                              value={father_fullname} onChange={(e) => setFatherFullName(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input type="text" className="form-control"
                              value={father_email} onChange={(e) => setFatherEmail(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Phone Number</label>
                            <input type="text" className="form-control"
                              value={father_contactno} onChange={(e) => setFatherContactNo(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Father Occupation
                            </label>
                            <input type="text" className="form-control"
                              value={father_occupation} onChange={(e) => setFatherOccupation(e.target.value)} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-bottom mb-3">
                      <h5 className="mb-3">Mother’s Info</h5>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">
                            <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                              {imageMotherPreview ? (
                                // Display the uploaded image preview
                                <img
                                  src={imageMotherPreview}
                                  alt="Uploaded Preview Mother Image"
                                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                              ) : (
                                // Display the default icon if no image is selected
                                <i className="ti ti-photo-plus fs-16" />
                              )}
                            </div>
                            <div className="profile-upload">
                              <div className="profile-uploader d-flex align-items-center">
                                <div className="drag-upload-btn mb-3">
                                  Upload
                                  <input
                                    type="file"
                                    className="form-control image-sign"
                                    name="imagemother"
                                    onChange={handleMotherImageChange}
                                  />
                                </div>
                                <Link to="#" className="btn btn-primary mb-3">
                                  Remove
                                </Link>
                              </div>
                              <p className="fs-12">
                                Upload image size 4MB, Format JPG, PNG, SVG
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Mother Title</label>
                            <Select
                              className="select"
                              options={title_data}
                              defaultValue={isEdit ? title_data[0] : undefined}
                              value={title_data.find(option => option.value === mother_titlename)}
                              onChange={handleMotherTitleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Mother Name</label>
                            <input type="text" className="form-control"
                              value={mother_fullname} onChange={(e) => setMotherFullName(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input type="text" className="form-control"
                              value={mother_email} onChange={(e) => setMotherEmail(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Phone Number</label>
                            <input type="text" className="form-control"
                              value={mother_contactno} onChange={(e) => setMotherContactNo(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Mother Occupation
                            </label>
                            <input type="text" className="form-control"
                              value={mother_occupation} onChange={(e) => setMotherOccupation(e.target.value)} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h5 className="mb-3">Guardian Details</h5>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-2">
                            <div className="d-flex align-items-center flex-wrap">
                              <label className="form-label text-dark fw-normal me-2">
                                If Guardian Is
                              </label>
                              <div className="form-check me-3 mb-2">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="guardian"
                                  id="parents"
                                  defaultChecked
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="parents"
                                >
                                  Parents
                                </label>
                              </div>
                              <div className="form-check me-3 mb-2">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="guardian"
                                  id="guardian"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="guardian"
                                >
                                  Guardian
                                </label>
                              </div>
                              <div className="form-check mb-2">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="guardian"
                                  id="other"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="other"
                                >
                                  Others
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">
                            <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                              {imageGuardianPreview ? (
                                // Display the uploaded image preview
                                <img
                                  src={imageGuardianPreview}
                                  alt="Uploaded Preview Guardian Image"
                                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                              ) : (
                                // Display the default icon if no image is selected
                                <i className="ti ti-photo-plus fs-16" />
                              )}
                            </div>
                            <div className="profile-upload">
                              <div className="profile-uploader d-flex align-items-center">
                                <div className="drag-upload-btn mb-3">
                                  Upload
                                  <input
                                    type="file"
                                    className="form-control image-sign"
                                    name="imageguardian"
                                    onChange={handleGuardianImageChange}
                                  />
                                </div>
                                <Link to="#" className="btn btn-primary mb-3">
                                  Remove
                                </Link>
                              </div>
                              <p className="fs-12">
                                Upload image size 4MB, Format JPG, PNG, SVG
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Guardian Title</label>
                            <Select
                              className="select"
                              options={title_data}
                              defaultValue={isEdit ? title_data[0] : undefined}
                              value={title_data.find(option => option.value === guardian_titlename)}
                              onChange={handleGuardianTitleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Guardian Name</label>
                            <input type="text" className="form-control"
                              value={guardian_fullname} onChange={(e) => setGuardianFullName(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Guardian Relation
                            </label>
                            <input type="text" className="form-control"
                              value={guardian_relation} onChange={(e) => setGuardianRelation(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Phone Number</label>
                            <input type="text" className="form-control"
                              value={guardian_contactno} onChange={(e) => setGuardianContactNo(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input type="email" className="form-control"
                              value={guardian_email} onChange={(e) => setGuardianEmail(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Occupation</label>
                            <input type="text" className="form-control"
                              value={guardian_occupation} onChange={(e) => setGuardianOccupation(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Address</label>
                            <input type="text" className="form-control"
                              value={guardian_address} onChange={(e) => setGuardianAddress(e.target.value)} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Parents & Guardian Information */}
                {/* Sibilings */}
                <div className="card">
                  <div className="card-header bg-light">
                    <div className="d-flex align-items-center">
                      <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                        <i className="ti ti-users fs-16" />
                      </span>
                      <h4 className="text-dark">Sibilings</h4>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="addsibling-info">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-2">
                            <label className="form-label">Sibling Info</label>
                            <div className="d-flex align-items-center flex-wrap">
                              <label className="form-label text-dark fw-normal me-2">
                                Is Sibling studying in the same school
                              </label>
                              <div className="form-check me-3 mb-2">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="sibling"
                                  id="yes"
                                  defaultChecked
                                />
                                <label className="form-check-label" htmlFor="yes">
                                  Yes
                                </label>
                              </div>
                              <div className="form-check mb-2">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="sibling"
                                  id="no"
                                />
                                <label className="form-check-label" htmlFor="no">
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        {newContents.map((_, index) => (
                          <div key={index} className="col-lg-12">
                            <div className="row">
                              <div className="col-lg-3 col-md-6">
                                <div className="mb-3">
                                  <label className="form-label">Name</label>
                                  <CommonSelect
                                    className="select"
                                    options={names}
                                    defaultValue={isEdit ? names[0] : undefined}
                                  />
                                </div>
                              </div>
                              {/* <div className="col-lg-3 col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Roll No</label>
                    <CommonSelect
                      className="select"
                      options={rollno}
                      defaultValue={isEdit?rollno[0]:undefined}
                    />
                  </div>
                </div> */}
                              <div className="col-lg-3 col-md-6">
                                <div className="mb-3">
                                  <label className="form-label">Admission No</label>
                                  <CommonSelect
                                    className="select"
                                    options={AdmissionNo}
                                    defaultValue={isEdit ? AdmissionNo[0] : undefined}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-6">
                                <div className="mb-3">
                                  <div className="d-flex align-items-center">
                                    <div className="w-100">
                                      <label className="form-label">Class</label>
                                      <CommonSelect
                                        className="select"
                                        options={allClass}
                                        defaultValue={isEdit ? allClass[0] : undefined}
                                      />
                                    </div>
                                    {newContents.length > 1 && (
                                      <div>
                                        <label className="form-label">&nbsp;</label>
                                        <Link
                                          to="#"
                                          className="trash-icon ms-3"
                                          onClick={() => removeContent(index)}
                                        >
                                          <i className="ti ti-trash-x" />
                                        </Link>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="border-top pt-3">
                      <Link
                        to="#"
                        onClick={addNewContent}
                        className="add-sibling btn btn-primary d-inline-flex align-items-center"
                      >
                        <i className="ti ti-circle-plus me-2" />
                        Add New
                      </Link>
                    </div>
                  </div>
                </div>
                {/* /Sibilings */}
                {/* Address */}
                <div className="card">
                  <div className="card-header bg-light">
                    <div className="d-flex align-items-center">
                      <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                        <i className="ti ti-map fs-16" />
                      </span>
                      <h4 className="text-dark">Address</h4>
                    </div>
                  </div>
                  <div className="card-body pb-1">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Current Address</label>
                          <input type="text" className="form-control"
                            value={current_address} onChange={(e) => setCurrentAddress(e.target.value)} />

                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Permanent Address
                          </label>
                          <input type="text" className="form-control"
                            value={permanent_address} onChange={(e) => setPermanentAddress(e.target.value)} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Address */}
                {/* Transport Information */}
                <div className="card">
                  <div className="card-header bg-light d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                        <i className="ti ti-bus-stop fs-16" />
                      </span>
                      <h4 className="text-dark">Transport Information</h4>
                    </div>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                      />
                    </div>
                  </div>
                  <div className="card-body pb-1">
                    <div className="row">
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Route</label>
                          <CommonSelect
                            className="select"
                            options={route}
                            defaultValue={isEdit ? route[0] : undefined}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Vehicle Number</label>
                          <CommonSelect
                            className="select"
                            options={VehicleNumber}
                            defaultValue={isEdit ? VehicleNumber[0] : undefined}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Pickup Point</label>
                          <CommonSelect
                            className="select"
                            options={PickupPoint}
                            defaultValue={isEdit ? PickupPoint[0] : undefined}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Transport Information */}
                {/* Hostel Information */}
                <div className="card">
                  <div className="card-header bg-light d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                        <i className="ti ti-building-fortress fs-16" />
                      </span>
                      <h4 className="text-dark">Hostel Information</h4>
                    </div>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                      />
                    </div>
                  </div>
                  <div className="card-body pb-1">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Hostel</label>
                          <CommonSelect
                            className="select"
                            options={Hostel}
                            defaultValue={isEdit ? Hostel[0] : undefined}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Room No</label>
                          <CommonSelect
                            className="select"
                            options={roomNO}
                            defaultValue={isEdit ? roomNO[0] : undefined}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Hostel Information */}
                {/* Documents */}
                <div className="card">
                  <div className="card-header bg-light">
                    <div className="d-flex align-items-center">
                      <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                        <i className="ti ti-file fs-16" />
                      </span>
                      <h4 className="text-dark">Documents</h4>
                    </div>
                  </div>
                  <div className="card-body pb-1">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="mb-2">
                          <div className="mb-3">
                            <label className="form-label mb-1">
                              Medical Condition
                            </label>
                            <p>Upload image size of 4MB, Accepted Format PDF</p>
                          </div>
                          <div className="d-flex align-items-center flex-wrap">
                            <div className="btn btn-primary drag-upload-btn mb-2 me-2">
                              <i className="ti ti-file-upload me-1" />
                              Change
                              <input
                                type="file"
                                className="form-control image_sign"
                                multiple
                              />
                            </div>
                            {isEdit ? <p className="mb-2">BirthCertificate.pdf</p> : <></>}

                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="mb-2">
                          <div className="mb-3">
                            <label className="form-label mb-1">
                              Upload Transfer Certificate
                            </label>
                            <p>Upload image size of 4MB, Accepted Format PDF</p>
                          </div>
                          <div className="d-flex align-items-center flex-wrap">
                            <div className="btn btn-primary drag-upload-btn mb-2">
                              <i className="ti ti-file-upload me-1" />
                              Upload Document
                              <input
                                type="file"
                                className="form-control image_sign"
                                multiple
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Documents */}
                {/* Medical History */}
                <div className="card">
                  <div className="card-header bg-light">
                    <div className="d-flex align-items-center">
                      <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                        <i className="ti ti-medical-cross fs-16" />
                      </span>
                      <h4 className="text-dark">Medical History</h4>
                    </div>
                  </div>
                  <div className="card-body pb-1">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-2">
                          <label className="form-label">
                            Medical Condition
                          </label>
                          <div className="d-flex align-items-center flex-wrap">
                            <label className="form-label text-dark fw-normal me-2">
                              Medical Condition of a Student
                            </label>
                            <div className="form-check me-3 mb-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="condition"
                                id="good"
                                defaultChecked
                              />
                              <label
                                className="form-check-label"
                                htmlFor="good"
                              >
                                Good
                              </label>
                            </div>
                            <div className="form-check me-3 mb-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="condition"
                                id="bad"
                              />
                              <label className="form-check-label" htmlFor="bad">
                                Bad
                              </label>
                            </div>
                            <div className="form-check mb-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="condition"
                                id="others"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="others"
                              >
                                Others
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Allergies</label>

                        <TagsInput
                          // className="input-tags form-control"
                          value={owner2}
                          onChange={setOwner2}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Medications</label>
                        <TagsInput
                          // className="input-tags form-control"
                          value={owner1}
                          onChange={setOwner1}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Medical History */}
                {/* Previous School details */}
                <div className="card">
                  <div className="card-header bg-light">
                    <div className="d-flex align-items-center">
                      <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                        <i className="ti ti-building fs-16" />
                      </span>
                      <h4 className="text-dark">Previous School Details</h4>
                    </div>
                  </div>
                  <div className="card-body pb-1">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">School Name</label>
                          <input type="text" className="form-control" defaultValue={isEdit ? 'Oxford Matriculation, USA' : undefined} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Address</label>
                          <input type="text" className="form-control" defaultValue={isEdit ? '1852 Barnes Avenue, Cincinnati, OH 45202' : undefined} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Previous School details */}
                {/* Other Details */}
                <div className="card">
                  <div className="card-header bg-light">
                    <div className="d-flex align-items-center">
                      <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                        <i className="ti ti-building-bank fs-16" />
                      </span>
                      <h4 className="text-dark">Other Details</h4>
                    </div>
                  </div>
                  <div className="card-body pb-1">
                    <div className="row">
                      <div className="col-md-5">
                        <div className="mb-3">
                          <label className="form-label">Bank Name</label>
                          <input type="text" className="form-control" defaultValue={isEdit ? 'CIMB Clicks' : undefined} />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-3">
                          <label className="form-label">Branch</label>
                          <input type="text" className="form-control" defaultValue={isEdit ? 'Kuala Lumpuer' : undefined} />
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="mb-3">
                          <label className="form-label">IFSC Number</label>
                          <input type="text" className="form-control" defaultValue={isEdit ? 'BOA83209832' : undefined} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Other Information
                          </label>
                          <textarea
                            className="form-control"
                            rows={3}
                            defaultValue={""}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Other Details */}
                <div className="text-end">
                  {/* <Link to={routes.studentList} className="btn btn-primary">
                    Add Student
                  </Link> */}
                  <button type="submit" className="btn btn-primary me-3">Add Student</button>
                  <button type="button" className="btn btn-light me-3">Cancel</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default AddStudent;
